import {
    EmailVerifyRequest,
    OauthSIgnInRequest, SendEmailRequest, SignInRequest, SignInResponse,
    SmsRequest, SmsVerifyRequest,
} from '@models/auth';

import instance from '../instance';

const baseUrl = '/auth';

class AuthApi {
    static oauthSIgnIn(request: OauthSIgnInRequest): Promise<SignInResponse> {
        return instance.post(`${baseUrl}/oauth/sign-in`, request);
    }

    static oauthSignInWithEmail(request: OauthSIgnInRequest): Promise<SignInResponse> {
        return instance.post(`${baseUrl}/oauth/sign-in/email`, request);
    }

    static sms(request: SmsRequest): Promise<unknown> {
        return instance.post(`${baseUrl}/sms`, request);
    }

    static verifySms(request: SmsVerifyRequest): Promise<unknown> {
        return instance.post(`${baseUrl}/sms/verify`, request);
    }

    static signInWithPhone(request: SignInRequest): Promise<SignInResponse> {
        return instance.post(`${baseUrl}/signin`, request);
    }

    static sendEmail(request: SendEmailRequest): Promise<never> {
        return instance.post('/auth/email', request);
    }

    static verifyEmail(request: EmailVerifyRequest): Promise<never> {
        return instance.post('/auth/email/verify', request);
    }

    static signIWithEmail(request: SendEmailRequest): Promise<SignInResponse> {
        return instance.post('/auth/signin/email', request);
    }

    static signOut(refreshToken: string) {
        return instance.post(`${baseUrl}/signout`, { refreshToken });
    }

    static reissueToken(refreshToken: string): Promise<SignInResponse> {
        return instance.post(`${baseUrl}/token/refresh`, { refreshToken });
    }

    static withdraw(refreshToken: string) {
        return instance.post('/auth/withdraw', { refreshToken });
    }
}

export default AuthApi;
